// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1Ua1A","head":"ProcedureTableInfo_head__2-JPn"};